// extracted by mini-css-extract-plugin
export default {"mainBlock":"Statistic_mainBlock__POxve","itemWrapper":"Statistic_itemWrapper__wtpe0","loading":"Statistic_loading__u5Jwt"};